import { Chip } from '@mui/material';
import { TextBlock, TextSpan } from '../../../Atoms/Text';

export interface EngagementCreatedConfirmationProps {
  engagementName: string;
  customerName: string;
  opportunityName: string | null;
  opportunityIsNew: boolean;
}

export const EngagementCreatedConfirmation = ({
  engagementName,
  customerName,
  opportunityName,
  opportunityIsNew
}: EngagementCreatedConfirmationProps) => {
  const rows = [
    { label: 'Engagement', value: engagementName, isNew: false },
    { label: 'Customer', value: customerName, isNew: false },
    ...(opportunityName ? [{ label: 'Opportunity', value: opportunityName, isNew: opportunityIsNew }] : [])
  ];

  return (
    <div
      className="flex flex-col gap-4"
      data-testid="engagement-created">
      <TextBlock
        size="sm14"
        color="grey8">
        {engagementName} is ready
      </TextBlock>
      <div className="flex flex-col gap-2">
        {rows.map((row) => (
          <div
            key={row.label}
            className="flex items-center gap-2">
            <TextSpan
              size="sm14"
              color="grey6"
              className="w-28 shrink-0">
              {row.label}
            </TextSpan>
            <TextSpan
              size="sm14"
              color="grey8">
              {row.value}
            </TextSpan>
            {row.isNew && (
              <Chip
                label="New"
                size="small"
                color="primary"
                variant="outlined"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
